import React, { type FC } from "react";

import { cn } from "@utilities/helper";

const NavWalletIcon: FC<{ isChecked?: boolean; className?: string }> = ({
  isChecked,
  className,
}) => (
  <svg
    className={cn(
      {
        "text-primary": isChecked,
        "text-gray-400 transition duration-300 group-hover:text-primary/80":
          !isChecked,
      },
      className,
    )}
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="inherit"
      d="M12.35 1.9V5.7H10.85V1.9C10.85 1.63 10.61 1.5 10.45 1.5C10.4 1.5 10.35 1.51 10.3 1.53L2.37 4.52C1.84 4.72 1.5 5.22 1.5 5.79V6.46C0.59 7.14 0 8.23 0 9.46V5.79C0 4.6 0.73 3.54 1.84 3.12L9.78 0.12C10 0.0400001 10.23 0 10.45 0C11.45 0 12.35 0.81 12.35 1.9Z"
    />
    <path
      fill="inherit"
      d="M19 12.45V13.45C19 13.72 18.79 13.94 18.51 13.95H17.05C16.52 13.95 16.04 13.56 16 13.04C15.97 12.73 16.09 12.44 16.29 12.24C16.47 12.05 16.72 11.95 16.99 11.95H18.5C18.79 11.96 19 12.18 19 12.45Z"
    />
    <path
      fill="inherit"
      d="M16.98 10.9H18C18.55 10.9 19 10.45 19 9.89995V9.45995C19 7.38995 17.31 5.69995 15.24 5.69995H3.76C2.91 5.69995 2.13 5.97995 1.5 6.45995C0.59 7.13995 0 8.22995 0 9.45995V16.19C0 18.26 1.69 19.95 3.76 19.95H15.24C17.31 19.95 19 18.26 19 16.19V16C19 15.45 18.55 15 18 15H17.13C16.17 15 15.25 14.41 15 13.48C14.79 12.72 15.04 11.99 15.54 11.5C15.91 11.12 16.42 10.9 16.98 10.9ZM11.5 10.7H4.5C4.09 10.7 3.75 10.36 3.75 9.94995C3.75 9.53995 4.09 9.19995 4.5 9.19995H11.5C11.91 9.19995 12.25 9.53995 12.25 9.94995C12.25 10.36 11.91 10.7 11.5 10.7Z"
    />
  </svg>
);

export default NavWalletIcon;
